import { type LaunchDarklyContext } from '../launch-darkly.types';
import { withGeneratedContextKey } from './with-generated-context-key';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Creates a Launch Darkly context with an anonymous user data.
 *
 * @see {@link https://docs.launchdarkly.com/sdk/features/user-context-config#configuring-context-objects User and context configuration}
 */
export function generateAnonymousUserContext(): LaunchDarklyContext {
  return {
    anonymous: true,
    ...withGeneratedContextKey(),
  };
}
